/**
 * Auth Module
 * Exports all authentication-related functionality
 */

export { AuthManager, getAuthManager } from './AuthManager';
export { AuthProvider, useAuth } from './AuthContext';
export type { AuthMode, ExternalAuthConfig } from './AuthContext';
export { EmailAuthProvider } from './providers/EmailAuthProvider';
export { OidcAuthProvider } from './providers/OidcAuthProvider';
export type { AuthProvider as IAuthProvider, UserContext, EmailCredentials, SignInResponse } from './types';
